import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import bmi from "../../Assets/Projects/BMI.png";
import weather from "../../Assets/Projects/Weather.png";

import chatify from "../../Assets/Projects/chatify.png";
import taskify from "../../Assets/Projects/Taskify.png";
import knowledge from "../../Assets/Projects/Knowledge.png";
import service from "../../Assets/Projects/Service.png";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={service}
              isBlog={false}
              title="On-Demand Service"
              description="A full-stack AI-powered web platform that connects users with local service providers—such as electricians, plumbers, and carpenters—through intelligent geospatial matching. It ensures users find nearby experts quickly while offering multilingual support for seamless communication, making services accessible to diverse communities and simplifying the process of finding reliable help."
              ghLink="https://github.com/AnkitKumar-1703/On_Demand_Service"
              demoLink="https://on-demand-service-omega.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={knowledge}
              isBlog={false}
              title="Knowledge Share"
              description="This full-stack blogging platform allows users to immerse themselves in a world of knowledge sharing. Whether you're looking to explore diverse perspectives, share your own experiences, or engage with a community of learners, this platform provides the perfect space."
              ghLink="https://github.com/AnkitKumar-1703/Medium-Blog-public"
              demoLink="https://medium-blog-pi-blond.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={weather}
              isBlog={false}
              title="Sky Cast"
              description="This app allows users to check the current weather conditions, astronomy data, and weather forecast for any city around the world. Powered by the DaisyUI plugin for Tailwind CSS, the app provides a sleek and modern user interface with support for both light and dark modes."
              ghLink="https://github.com/AnkitKumar-1703/Weather-app"
              demoLink="https://weather-app-gamma-seven-42.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Meme Bot"
              description="Meme Bot is a fun and engaging Discord bot designed to share random memes with users. By leveraging the Meme API, the bot fetches and delivers a fresh meme whenever prompted. Ideal for community servers looking to add a touch of humor to their conversations, Meme Bot is easy to integrate and use."
              ghLink="https://github.com/AnkitKumar-1703/Discord-meme-bot"
                         
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={taskify}
              isBlog={false}
              title="Taskify"
              description="Taskify is a full-stack to-do application that enables users to create, read, update, and delete tasks. It offers a simple, responsive interface for organizing and tracking personal or professional to-dos, making task management more efficient and user-friendly."
              ghLink="https://github.com/AnkitKumar-1703/To_Do-App"
              demoLink="https://to-do-app-five-ecru-18.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bmi}
              isBlog={false}
              title="FitCal"
              description="A full-stack application for calculating Body Mass Index (BMI) using user input ."
              ghLink="https://github.com/AnkitKumar-1703/BMI-Calculator"
              demoLink="https://ankitkumar-1703.github.io/BMI-frontend/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
